import { clientTypes } from './actions';
import { readInviteTotal } from '../utils/inviteJourney';

const initialState = {
  clients: [],
  /** Lista completa per i selettori (prenotazione). Non va sovrascritta da GET_CLIENTS_PLUS (paginata). */
  allClients: [],
  activeClient: {},
  prenotazione: {},
  inviti_onboarding: 0,
  inviti_onboarding_tot: 0,
  badClients: [],
  listMeta: {
    page: 1,
    limit: 20,
    total: 0,
    totalPages: 0,
  },
  listStats: null,
};

const inviteQuotaFromPayload = (state, payload) => {
  if (!payload || typeof payload !== 'object') return {};
  const hasRemaining = payload.inviti_onboarding !== undefined && payload.inviti_onboarding !== null;
  const hasTotal = Object.prototype.hasOwnProperty.call(payload, 'inviti_onboarding_tot');
  const total = hasTotal ? readInviteTotal(payload.inviti_onboarding_tot) : null;
  if (!hasRemaining && total == null) return {};
  return {
    ...(hasRemaining ? { inviti_onboarding: payload.inviti_onboarding } : {}),
    ...(total != null ? { inviti_onboarding_tot: total } : {}),
  };
};

export default (state = initialState, action) => {
  switch (action.type) {
    case clientTypes.GET_CLIENTS.SUCCESS: {
      const clienti = Array.isArray(action.payload?.clienti) ? action.payload.clienti : [];
      return {
        ...state,
        allClients: clienti,
        ...inviteQuotaFromPayload(state, action.payload),
      };
    }
    case clientTypes.GET_CLIENTS_PLUS.SUCCESS: {
      const pagination = action.payload?.pagination || {};
      return {
        ...state,
        clients: Array.isArray(action.payload?.clienti) ? action.payload.clienti : [],
        listMeta: {
          page: Number(pagination.page) || 1,
          limit: Number(pagination.limit) || 20,
          total: Number(pagination.total) || 0,
          totalPages: Number(pagination.totalPages) || 0,
        },
        // stats ufficiali da /stats; fallback se list le include ancora
        listStats: action.payload?.stats || state.listStats,
        ...inviteQuotaFromPayload(state, action.payload),
      };
    }
    // Non azzerare listStats su REQUEST: i chip restano leggibili durante il soft-refresh
    case clientTypes.GET_CLIENTS_STATS.SUCCESS:
      return {
        ...state,
        listStats: action.payload?.stats || action.payload || null,
      };
    case clientTypes.GET_CLIENTS_COUNTERS.SUCCESS: {
      const counters = Array.isArray(action.payload?.counters)
        ? action.payload.counters
        : Array.isArray(action.payload)
          ? action.payload
          : [];
      if (!counters.length) return state;
      const byId = counters.reduce((acc, row) => {
        const id = row?.idutente ?? row?.id;
        if (id == null || id === '') return acc;
        acc[String(id)] = row;
        return acc;
      }, {});
      // Ignora risposta stale (page precedente) se nessun id è nella lista corrente
      let hit = false;
      const clients = state.clients.map((client) => {
        const row = byId[String(client.idutente)];
        if (!row) return client;
        hit = true;
        return {
          ...client,
          totPren: row.totPren ?? row.tot_pren ?? row.totPrenotazioni,
          lastPren: row.lastPren ?? row.last_pren ?? row.ultimaPrenotazione,
        };
      });
      if (!hit) return state;
      return { ...state, clients };
    }
    case clientTypes.GET_CLIENT.SUCCESS:
      return {
        ...state,
        activeClient: action.payload,
      };
    case clientTypes.ADD_CLIENT.SUCCESS: {
      const user = action.payload.user;
      return {
        ...state,
        clients: [...state.clients, user],
        allClients: [...(state.allClients || []), user],
      };
    }
    case clientTypes.EDIT_CLIENT.SUCCESS:
      return {
        ...state,
        clients: state.clients.map((client) =>
          +client.idutente === +action.payload.idutente
            ? {
                ...client,
                ...action.payload,
              }
            : client,
        ),
        allClients: (state.allClients || []).map((client) =>
          +client.idutente === +action.payload.idutente
            ? {
                ...client,
                ...action.payload,
              }
            : client,
        ),
        activeClient: {
          ...state.activeClient,
          cliente: {
            ...state.activeClient.cliente,
            ...action.payload,
          },
        },
      };
    case clientTypes.EDIT_CLIENT_PHONE.SUCCESS: {
      const { user, phone, verified } = action.payload;
      const id = user?.idutente;
      if (!id) return state;

      const verifiedValue = verified ? 1 : 0;

      return {
        ...state,
        clients: state.clients.map((client) =>
          +client.idutente === +id
            ? {
                ...client,
                cellulare: phone,
                cellulare_verificato: verifiedValue,
              }
            : client,
        ),
        allClients: (state.allClients || []).map((client) =>
          +client.idutente === +id
            ? {
                ...client,
                cellulare: phone,
                cellulare_verificato: verifiedValue,
              }
            : client,
        ),
        activeClient:
          +state.activeClient?.cliente?.idutente === +id
            ? {
                ...state.activeClient,
                cliente: {
                  ...state.activeClient.cliente,
                  cellulare: phone,
                  cellulare_verificato: verifiedValue,
                },
              }
            : state.activeClient,
      };
    }
    case clientTypes.DELETE_CLIENT.SUCCESS:
      return {
        ...state,
        clients: state.clients.map((client) =>
          +client.idutente !== +action.payload
            ? client
            : {
                ...client,
                disabilitato: 1,
              },
        ),
        allClients: (state.allClients || []).map((client) =>
          +client.idutente !== +action.payload
            ? client
            : {
                ...client,
                disabilitato: 1,
              },
        ),
      };
    case clientTypes.ENABLE_CLIENT.SUCCESS:
      return {
        ...state,
        clients: state.clients.filter((client) =>
          (+client.idutente !== +action.payload + client.idutente) !== +action.payload
            ? client
            : {
                ...client,
                disabilitato: 0,
              },
        ),
      };
    case clientTypes.DELETE_CLIENT_APPOINTMENT.SUCCESS:
      return {
        ...state,
        activeClient: {
          ...state.activeClient,
          prenotazioni: state.activeClient.prenotazioni.filter(
            (appointment) => +appointment.idprenotazione !== +action.payload,
          ),
        },
      };

    case clientTypes.GET_PRENOTAZIONE_BY_ID.SUCCESS:
      return {
        ...state,
        prenotazione: action.payload,
      };
    case clientTypes.GET_BAD_CLIENTS.SUCCESS:
      return {
        ...state,
        badClients: action.payload.clienti,
      };
    default:
      return { ...state };
  }
};
